import React from 'react';
import BackIcon from '@menuzen/icon/build/outline/Back';
import { LoadingButton } from '@mui/lab';
import IFrame, { FrameContextConsumer } from 'react-frame-component';
import { StyleSheetManager } from 'styled-components';
import { Account, DesignSettings, Frame, SerializedNodes } from '@mnz/builder';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

interface DesignPreviewProps {
    data: string | SerializedNodes;
    designSettings: DesignSettings;
    account: Account;
    onBack: () => void;
    onClickPublish: () => Promise<void>;
    isPublishing: boolean;
}

const PreviewPage: React.FC<DesignPreviewProps> = ({
    data,
    designSettings,
    account,
    onBack,
    onClickPublish,
    isPublishing,
}) => {
    return (
        <div className="flex flex-col flex-auto bg-grey-light-extra overflow-y-auto">
            <div className={`pt-28 px-30 pb-20 flex items-center justify-between`}>
                <div className={`flex items-center justify-start cursor-pointer`} onClick={onBack}>
                    <div className="text-25 mr-8">
                        <BackIcon />
                    </div>
                    <p className="text-14">Edit</p>
                </div>
                <LoadingButton
                    color="primary"
                    variant="contained"
                    size={`small`}
                    onClick={onClickPublish}
                    loading={isPublishing}
                >
                    Publish
                </LoadingButton>
            </div>
            <div className="flex flex-col flex-auto overflow-y-auto">
                <IFrame
                    initialContent={`<!DOCTYPE html><html><head></head><body><div class="frame-root"></div></body></html>`}
                    style={{
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <FrameContextConsumer>
                        {({ document }) => {
                            return (
                                <StyleSheetManager target={document?.head}>
                                    <CacheProvider
                                        value={createCache({
                                            key: 'css',
                                            container: document?.head,
                                            prepend: true,
                                        })}
                                    >
                                        <Frame
                                            data={data}
                                            config={{
                                                fontEndpoint: process.env.REACT_APP_FONT_PATH as string,
                                            }}
                                            designSettings={{
                                                ...designSettings,
                                            }}
                                            account={account}
                                        ></Frame>
                                    </CacheProvider>
                                </StyleSheetManager>
                            );
                        }}
                    </FrameContextConsumer>
                </IFrame>
            </div>
        </div>
    );
};

export default PreviewPage;
